import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/events", label: "Experiences" },
  { to: "/#manifesto", label: "Why We Exist" },
  { to: "/#tribe", label: "Join the Tribe" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-cream border-b border-ink/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <span className="font-serif text-2xl leading-none text-ink">The Plus One Tribe</span>
          <span className="text-terracotta text-2xl leading-none group-hover:rotate-90 transition-transform duration-500">+</span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-xs uppercase tracking-[0.15em] text-ink/70 hover:text-terracotta transition-colors ${
                pathname === l.to ? "text-terracotta" : ""
              }`}
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/events"
            data-testid="header-cta"
            className="bg-terracotta text-cream text-xs uppercase tracking-[0.15em] px-6 py-2.5 rounded-full hover:bg-terracotta-dark transition-colors"
          >
            Find a table
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-ink"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-ink/10 bg-cream px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.to}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.15em] text-ink/80"
            >
              {l.label}
            </a>
          ))}
          <Link to="/events" onClick={() => setOpen(false)} className="bg-terracotta text-cream text-center text-xs uppercase tracking-[0.15em] px-6 py-3 rounded-full">
            Find a table
          </Link>
        </div>
      )}
    </header>
  );
};
